import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorBlobComponent } from '@shared/components/error-blob/error-blob.component';

@Component({
  selector: 'app-error-401',
  imports: [
    ErrorBlobComponent
  ],
  templateUrl: './error-401.component.html',
  styleUrl: './error-401.component.css'
})
export class Error401Component {
  public router: Router = inject(Router);

}
